import React, { useEffect, useState } from "react";

const StealthModeSwitch = ({ onToggle }) => {
  const [stealthMode, setStealthMode] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("stealth_mode");
    if (stored === "true") setStealthMode(true);
  }, []);

  const handleToggle = () => {
    const newValue = !stealthMode;
    setStealthMode(newValue);
    localStorage.setItem("stealth_mode", newValue.toString());
    if (onToggle) onToggle(newValue); // Signal to parent to disable sound/vibration
  };

  return (
    <label style={styles.container}>
      <span style={styles.label}>Stealth Mode</span>
      <div
        style={{
          ...styles.switch,
          backgroundColor: stealthMode ? "#103256" : "#6b7280",
        }}
        onClick={handleToggle}
      >
        <div
          style={{
            ...styles.ball,
            left: stealthMode ? "21px" : "1px",
          }}
        />
      </div>
    </label>
  );
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    cursor: "pointer",
    userSelect: "none",
    margin: 0,
    padding: 0,
  },
  label: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#374151", // Regular dark text
    margin: 0,
    padding: 0,
  },
  switch: {
    width: "42px",
    height: "22px",
    borderRadius: "22px",
    position: "relative",
    transition: "background-color 0.3s",
    boxSizing: "border-box",
  },
  ball: {
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    backgroundColor: "#fff",
    position: "absolute",
    top: "2px",
    transition: "left 0.25s ease-in-out",
    left: "1px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.4)",
  },
};

export default StealthModeSwitch;
